import { Form } from "react-bootstrap";
import { parseDomain, ParseResultType } from 'parse-domain';

export default function ClientAgreement() {
  let hostname = "";
  const parseResult = parseDomain(typeof window !== 'undefined' && window.location.hostname ? window.location.hostname : '');
  if (parseResult.type === ParseResultType.Listed) {
    const { domain, topLevelDomains } = parseResult;
    hostname = domain + "." + topLevelDomains;
  }
  return (
    <div>
      <h5>Client Agreement</h5>
      <Form.Group controlId="ClientAgreement">
        <Form.Check required type="checkbox" label={"By checking this box: (i) I affirm that all the information provided above is complete and accurate; (ii) I agree that I have carefully read and accept the website’s Terms of Use; and (iii) I acknowledge that I am authorizing " + hostname + " to act as a third-party designee to apply to the IRS for an Employer Identification Number for the individual or entity listed above, answer any Form SS-4 completion questions on my or the entity’s behalf, and receive and deliver the EIN to me or the entity."} />
      </Form.Group>
    </div>
  );
}
